import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  cursor: ${props => (props.slug !== "" ? "pointer" : "zoom-in")};

  :hover .contentOverlay {
    opacity: 0.9;
  }

  .contentOverlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: 0.5s ease;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: ${props => (props.slug !== "" ? "pointer" : "zoom-in")};

    > p {
      display: block;
    }

    > span {
      text-decoration: underline;
      color: white;
      font-size: 0.7em;
    }

    &.-landscape {
      top: 0;
      width: 40%;
      height: 100%;
    }

    &.-portrait {
      bottom: 0%;
      height: 40%;
      width: 100%;
    }

    &.-vague {
      top: 0;
      height: 100%;
      width: 100%;

      .title {
        font-size: 2.2em;
        text-transform: uppercase;
      }

      .subtitle {
        font-size: 1.2em;
      }
    }
  }

  .title,
  .subtitle {
    color: white;
    text-align: center;
    margin-top: 15px;
  }

  .title {
    font-size: 1.2em;
  }

  .subtitle {
    font-size: 0.7em;
  }

  @media only screen and (max-width: 1024px),
    only screen and (max-device-width: 1366px) and (orientation: landscape) {
    .contentOverlay {
      opacity: 0.9;
    }
  }

  @media screen and (max-width: 480px) {
    .contentOverlay {
      &.-vague {
        .title {
          font-size: 0.5em;
        }

        .subtitle {
          font-size: 0.3em;
        }
      }
    }

    .title {
      font-size: 0.5em;
    }
    .subtitle {
      font-size: 8px;
    }
  }
`

const MasonryItem = ({ title, subtitle, children, orientation, action }) => {
  return (
    <Container onClick={action}>
      {children}
      <div className={`contentOverlay -${orientation}`}>
        <p className="title">{title}</p>
        <p className="subtitle">{subtitle}</p>
      </div>
    </Container>
  )
}

MasonryItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  children: PropTypes.node.isRequired,
  action: PropTypes.func.isRequired,
}

MasonryItem.defaultProps = {
  orientation: "portrait",
}

export default MasonryItem
